
function Dipgestpublicamoderna(){
   return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Gestión Pública Moderna ha sido diseñado 
                    para brindar una formación integral y actualizada en los principales sistemas 
                    administrativos, herramientas estratégicas y enfoques innovadores de la gestión pública, 
                    alineados con las nuevas tendencias de modernización y gobernanza.
               </p>
               <p>
                    El programa desarrolla contenidos en planificación estratégica, presupuesto público, 
                    gestión por resultados, políticas públicas, control gubernamental e innovación pública, 
                    promoviendo una visión moderna, eficiente y orientada al servicio ciudadano.
               </p>

                <ul>
                    <h1> Objetivo Específico </h1>
                    <ul>
                        <li>
                            Desarrollar y fortalecer competencias técnicas y estratégicas en los 
                            profesionales del sector público, proporcionando herramientas modernas 
                            de gestión que permitan diseñar, implementar y evaluar políticas, planes 
                            y proyectos con eficiencia, transparencia y enfoque en resultados.
                        </li>
                    </ul>
                </ul>
            </div>

            <div className="metedologia">
                <img src='/uploads/curs_proyecto_bim.png' alt='logo-de-metodologia' className='logo-metodologia'/>
                
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>
                            Escuela de Gerencia y Gestión S.A.C
                        </p>
                        <p>
                            📱 Teléfonos y WhatsApp: 913376365 / 948251685
                        </p>
                        <p>
                            📧 Correos: esscuelag@gmail.com | capacita@escuelag.com
                        </p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Planificación Estratégica </li>
                    <li> 2. Presupuesto Público </li>
                    <li> 3. Gestión por Resultados </li>
                    <li> 4. Políticas Públicas </li>
                    <li> 5. Control Gubernamental </li>
                    <li> 6. Innovación Pública </li>
                </ul>
            </div>
        </div>
    );
}

export default Dipgestpublicamoderna
